const SvgIcon = ({ size='24', color='#fff'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <path d="m16 12-4-4-4 4M12 16V8"></path>
  </svg>
);

export default SvgIcon;

